module.exports = __webpack_public_path__ + "img/revenue-capture.15d1cb62.svg";